import { useNotificationSound } from "@/hooks/useNotificationSound";

/**
 * Invisible component that enables custom notification sound playback.
 * Must be mounted inside a toast provider context.
 */
export function NotificationSoundProvider() {
  useNotificationSound();
  return null;
}
